const acceptedPapers = []
    export default acceptedPapers;